import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  const tilesRef = useRef([]);

  useEffect(() => {
    // Intersection Observer for scroll animations
    const observerOptions = {
      threshold: 0.15,
      rootMargin: '0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('category-tile--visible');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    tilesRef.current.forEach(tile => {
      if (tile) observer.observe(tile);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="home">
      {/* Hero Split Layout */}
      <section className="hero">
        <div className="hero__brand">
          <h1 className="hero__title">blue hour</h1>
        </div>
        <div className="hero__image">
          <img
            src="https://pruebasventaenlinea.s3.us-east-2.amazonaws.com/openv1.jpeg"
            alt="Blue Hour Collection"
            loading="eager"
          />
        </div>
      </section>

      {/* Category Tiles */}
      <section className="categories">
        <div className="categories__container">
          {/* Line 1: Outerwear and Vintage */}
          <Link
            to="/shop/brand-denim"
            className="category-tile"
            ref={el => tilesRef.current[0] = el}
          >
            <div className="category-tile__image">
              <img
                src="https://pruebasventaenlinea.s3.us-east-2.amazonaws.com/homepagev2.jpeg"
                alt="Denim Collection"
                loading="lazy"
              />
              <div className="category-tile__overlay"></div>
            </div>
            <h2 className="category-tile__title">denim</h2>
          </Link>

          <Link
            to="/shop/vintage"
            className="category-tile"
            ref={el => tilesRef.current[1] = el}
          >
            <div className="category-tile__image">
              <img
                src="https://pruebasventaenlinea.s3.us-east-2.amazonaws.com/homepagev1.jpeg"
                alt="Vintage Collection"
                loading="lazy"
              />
              <div className="category-tile__overlay"></div>
            </div>
            <h2 className="category-tile__title">vintage</h2>
          </Link>

          {/* Line 2: Outerwear (full width, image only, no text, not clickable) */}
          <div
            className="category-tile category-tile--full category-tile--image-only"
            ref={el => tilesRef.current[2] = el}
          >
            <div className="category-tile__image">
              <img
                src="https://pruebasventaenlinea.s3.us-east-2.amazonaws.com/bosque.jpeg"
                alt="Outerwear Collection"
                loading="lazy"
              />
            </div>
          </div>

          {/* Line 3: Instagram and Accessories */}
          <a
            href="https://www.instagram.com/bluehourlab"
            target="_blank"
            rel="noopener noreferrer"
            className="category-tile"
            ref={el => tilesRef.current[3] = el}
          >
            <div className="category-tile__image">
              <img
                src="https://pruebasventaenlinea.s3.us-east-2.amazonaws.com/coches.jpeg"
                alt="Instagram"
                loading="lazy"
              />
              <div className="category-tile__overlay"></div>
            </div>
            <h2 className="category-tile__title">instagram</h2>
          </a>

          <Link
            to="/under-construction"
            className="category-tile"
            ref={el => tilesRef.current[4] = el}
          >
            <div className="category-tile__image">
              <img
                src="https://pruebasventaenlinea.s3.us-east-2.amazonaws.com/accesorios.jpeg"
                alt="Accessories Collection"
                loading="lazy"
              />
              <div className="category-tile__overlay"></div>
            </div>
            <h2 className="category-tile__title">accessories</h2>
          </Link>

          {/* Line 4: Ocean Blue (full width) */}
          <Link
            to="/shop/brand-denim"
            className="category-tile category-tile--full"
            ref={el => tilesRef.current[5] = el}
          >
            <div className="category-tile__image">
              <img
                src="https://pruebasventaenlinea.s3.us-east-2.amazonaws.com/oceanblue.jpeg"
                alt="Collection"
                loading="lazy"
              />
              <div className="category-tile__overlay"></div>
            </div>
            <h2 className="category-tile__title">collection</h2>
          </Link>

          {/* Line 5: Video (full width, no text, not clickable) */}
          <div
            className="category-tile category-tile--full category-tile--video"
            ref={el => tilesRef.current[6] = el}
          >
            <div className="category-tile__video">
              <video
                autoPlay
                muted
                loop
                playsInline
                preload="metadata"
              >
                <source src="https://pruebasventaenlinea.s3.us-east-2.amazonaws.com/IMG_2492.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
